import { message, Modal } from "antd";
import {
  formatPersonName,
  formatPhoneNumber,
  redirectFileLocalUrl,
} from "shared/plugins/string-helper";
import { OrderModel } from "states/order/order.models";
import moment from "moment-timezone";
import {
  momentDateFormat,
  momentDateTimeFormat,
} from "shared/plugins/localization";

// export default function usePrinter(ip: string) {
//   const [loading, setLoading] = useState<boolean>(false);
//   const [success, setSuccess] = useState<boolean>(false);
//   const [data, setData] = useState<string>("");
//   let printer: any;
//   let printCallback: any;
//   let ePosDev: any;
//   let handler: any;
//   const loadScriptEpsonPrint = () => {
//     let url = redirectFileLocalUrl("/epson/js/epos-2.18.0.js");
//     if (document.querySelector("script[src='" + url + "']") !== null) {
//       return;
//     }
//     const script = document.createElement("script");
//     script.src = url;
//     document.head.appendChild(script);
//   };
//   const loadMeta = () => {
//     if (process.env.NODE_ENV === "production") {
//       if (
//         document.querySelector("meta[http-equiv='Content-Security-Policy']") !==
//         null
//       ) {
//         return;
//       }
//       const meta = document.createElement("meta");
//       meta.setAttribute("http-equiv", "Content-Security-Policy");
//       meta.setAttribute("content", "upgrade-insecure-requests");
//       document.head.appendChild(meta);
//     }
//   };
//   const callback_deleteDevice = (errorCode: any) => {
//     //Terminates connection with device
//     ePosDev.disconnect();
//   };
//   const cbConnect = (data: any) => {
//     if (data === "OK" || data === "SSL_CONNECT_OK") {
//       ePosDev.createDevice(
//         "local_printer",
//         ePosDev.DEVICE_TYPE_PRINTER,
//         { crypto: false, buffer: false },
//         cbCreateDevice_printer
//       );
//     } else {
//       alert("Error connect");
//       setLoading(false);
//     }
//   };
//   const cbCreateDevice_printer = (devObj: any, retcode: any) => {
//     if (devObj === null) {
//       alert(retcode);
//     }
//     if (retcode === "OK") {
//       printer = devObj;
//       printer.timeout = 60000;
//       printer.onreceive = (response: any) => {
//         if (response.printjobid.length > 0) {
//         } else {
//         }
//       };
//       printer.onerror = function (response: any) {};
//       printer.ononline = function () {};
//       printer.onoffline = function () {};
//       printer.onpoweroff = function () {};
//       printer.oncoverok = function () {};
//       printer.oncoveropen = function () {};
//       printer.onpaperok = function () {};
//       printer.onpapernearend = function () {};
//       printer.onpaperend = function () {};
//       printer.ondrawerclosed = function () {};
//       printer.ondraweropen = function () {};
//       printer.onbatterylow = function () {};
//       printer.onbatteryok = function () {};
//       printer.onbatterystatuschange = function (response: any) {
//         if (response > 0) {
//         }
//       };
//       if (printCallback) {
//         printCallback();
//         printCallback = null;
//       }
//       setLoading(false);
//     }
//   };
//   const connectPrinter = () => {
//     setLoading(true);
//     // if(ip !== "" && ip !== undefined){
//     //   onLogin();
//     // }
//     handler = setTimeout(() => {
//       if (ePosDev == null) {
//         ePosDev = new window.epson.ePOSDevice();
//       }
//       ePosDev.ondisconnect = function () {
//         printer = null;
//       };
//       if (ip === "" || ip === undefined) {
//         return;
//       }
//       ePosDev.connect(
//         ip,
//         window.location.protocol === "https:" ? "8043" : "8008",
//         cbConnect
//       );
//     }, 500);
//   };
//   const onLogin = () => {
//     let wOpen = window.open(`${window.location.protocol}//${ip}`) as Window;
//     wOpen.addEventListener(
//       "load",
//       () => {
//         console.log(window.atob("dGhpc2lzdW5zYWZl"));
//         const xhttp = new XMLHttpRequest();
//         xhttp.open(
//           "GET",
//           `${window.location.protocol}//epson:epson@${ip}`,
//           true
//         );
//         xhttp.send();
//         wOpen.close();
//       },
//       true
//     );
//   };

//   const sendPrintDoc = () => {
//     if (printer) {
//       doSendPrintDoc();
//     } else {
//       printCallback = doSendPrintDoc;
//       connectPrinter();
//     }
//     if (ePosDev != null) {
//       ePosDev.deleteDevice(printer, callback_deleteDevice);
//     }
//   };
//   const doSendPrintDoc = () => {
//     if (printer) {
//       printer.setXmlString(data);
//       printer.send();
//       message.success("Print order successfully");
//     }
//   };
//   useEffect(() => {
//     // loadMeta();
//     loadScriptEpsonPrint();
//   }, []);
//   useEffect(() => {
//     if (data !== "") {
//       // setSuccess(false);
//       sendPrintDoc();
//     }
//   }, [data]);
//   useEffect(() => {
//     connectPrinter();
//     return () => handler && clearTimeout(handler);
//   }, [ip, handler]);

//   return [loading, success, setData] as const;
// }

export function printTheOrder(order: OrderModel, logo: string) {
  let ePosDev: any;
  let printer: any;
  const printData = formatOrderToPrint(order, logo);

  const onPrinterCreated = (devObj: any, retcode: any) => {
    if (devObj === null) {
      alert(retcode);
    }
    if (retcode === "OK") {
      printer = devObj;
      printer.timeout = 60000;
      printer.onreceive = (response: any) => {
        if (response.printjobid.length > 0) {
        } else {
        }
      };
      printer.onerror = function (response: any) {};
      printer.ononline = function () {};
      printer.onoffline = function () {};
      printer.onpoweroff = function () {};
      printer.oncoverok = function () {};
      printer.oncoveropen = function () {};
      printer.onpaperok = function () {};
      printer.onpapernearend = function () {};
      printer.onpaperend = function () {};
      printer.ondrawerclosed = function () {};
      printer.ondraweropen = function () {};
      printer.onbatterylow = function () {};
      printer.onbatteryok = function () {};
      printer.onbatterystatuschange = function (response: any) {
        if (response > 0) {
        }
      };
      printer.setXmlString(printData);
      printer.send();
      message.success("Print order successfully");

      ePosDev.deleteDevice(printer, () => {
        ePosDev.disconnect();
      });
    }
  };

  const onConnected = (connectResult: any) => {
    if (connectResult === "OK" || connectResult === "SSL_CONNECT_OK") {
      ePosDev.createDevice(
        "local_printer",
        ePosDev.DEVICE_TYPE_PRINTER,
        { crypto: false, buffer: false },
        onPrinterCreated
      );
    } else {
      ePosDev.disconnect();
      Modal.warning({
        title: "Warning",
        content: (
          <>
            The printer can't be connected, Please click{" "}
            <a
              target="_blank"
              href={`https://${order.branch.defaultPrinterIp}`}
              rel="noreferrer"
            >
              here
            </a>{" "}
            to setup connection
          </>
        ),
      });
    }
  };

  const connectPrinterAndPrint = () => {
    if (ePosDev == null) {
      ePosDev = new window.epson.ePOSDevice();
    }
    ePosDev.ondisconnect = function () {
      printer = null;
    };
    if (
      order.branch.defaultPrinterIp === "" ||
      order.branch.defaultPrinterIp === undefined
    ) {
      return;
    }
    ePosDev.connect(
      order.branch.defaultPrinterIp,
      window.location.protocol === "https:" ? "8043" : "8008",
      onConnected
    );
  };

  connectPrinterAndPrint();
}

export function testPrinterConnection(ip: string) {
  let ePosDev = new window.epson.ePOSDevice();
  ePosDev.connect(
    ip,
    8043,
    // window.location.protocol === "https:" ? "8043" : "8008",
    (connectResult: any) => {
      if (connectResult !== "OK" && connectResult !== "SSL_CONNECT_OK") {
        ePosDev.disconnect();
        Modal.warning({
          title: "Warning",
          content: (
            <>
              The printer can't be connected, Please click{" "}
              <a target="_blank" href={`https://${ip}`} rel="noreferrer">
                here
              </a>{" "}
              to setup connection
            </>
          ),
        });
      } else {
        ePosDev.disconnect();
      }
    }
  );
}

function formatOrderToPrint(order: OrderModel, logo: string) {
  return `<text align="center"/>
      <text smooth="true"/>
      <layout type="receipt" width="800" height="0" margin-top="-150" margin-bottom="0" offset-cut="-290" offset-label="0"/>
      ${logo}
      <text>&#10;</text>
      <text font="font_a"/>
      <text>${order.branch?.address?.street}&#10; ${
    order.branch?.address?.provinceName
  }, ${order.branch?.address?.stateCode} ${
    order.branch?.address?.postalCode
  }</text>
      <text>&#10;</text>
      <text>${
        order.branch?.phone && formatPhoneNumber(order.branch?.phone)
      }&#10;</text>
      <text>********************* &#10;</text>
      <text width="1" height="1"/>
      <text>WEB ORDER / TAKE-OUT &#10;</text>
      <text width="1" height="1"/>
      <text>********************* &#10;</text>
      <text width="1" height="1"/>
      <text>${formatPersonName(
        order.customer?.firstName,
        order.customer?.lastName
      )}&#10;&#10;</text>
      <text width="1" height="1"/>
      <text align="left"/>
      <text>Order time: ${
        order.creationTime &&
        moment(order.creationTime)
          .tz(order.branch.ianaTimeZone)
          .format(momentDateTimeFormat())
      }&#10;</text>
      <text>Notes: Pick-up &#10;</text>
      <text>Request pick up:  </text>
      <text width="2" height="1"/>
      <text reverse="false" ul="false" em="true" color="color_1"/>
      <text>${
        order.requestPickupTime
          ? `${moment(order.requestPickupTime)
              .tz(order.branch.ianaTimeZone)
              .format(momentDateFormat())}&#10;         ${moment(
              order.requestPickupTime
            )
              .tz(order.branch.ianaTimeZone)
              .format("hh:mm A")}`
          : ""
      } &#10;&#10;</text>
      <text reverse="false" ul="false" em="false" color="color_1"/>
      <text width="2" height="1"/>
      ${order.orderItems.map(
        (item) =>
          `<text>${formatNamePrint(
            `${item.product?.name} x${item.quantity}`
          )}&#10;</text> ${
            item?.modifiers?.length > 0
              ? `<text>*` +
                item?.modifiers.map((modi) => {
                  return `${modi.product?.name}`;
                }) +
                `&#10;</text>`
              : ``
          }<text>&#10;</text>`
      )}
      <text width="1" height="1"/>
      <text>&#10;</text>
      <text align="center"/>
      <text reverse="true" ul="true" em="true" color="color_1"/>
      <text>&#10;</text>
      <text>Item count: ${order.orderItems
        .map((m) => m.quantity)
        ?.reduce((a, b) => a + b, 0)} &#10;</text>
      <text reverse="false" ul="false" em="false" color="color_1"/>
      <barcode type="code39" hri="below" font="font_a" width="2" height="32">${
        order.orderNumber
      }</barcode>
      <text>Printed: ${moment(new Date())
        .tz(order.branch.ianaTimeZone)
        .format(momentDateTimeFormat())} &#10;</text>
      <cut type="feed"/>
      `;
}

function formatNamePrint(name: string) {
  name = name.trim();
  if (name.indexOf("  ") > -1) {
    name = name.replaceAll("  ", " ");
  }
  if (name !== "" && name.length > 24 && name.split(" ").length > 3) {
    let nameArray = name.split(" ");
    nameArray = nameArray.map((n, index) => {
      if (index === 2) {
        n = n + "&#10;";
      }
      return n;
    });
    return nameArray.join(" ");
  }
  return name;
}
